<template>
  <slick-list
    class="col-12 f-widget-list"
    lock-axis="y"
    :use-drag-handle="true"
    :pressDelay="20"
    :value="fields"
    @input="fields_changed"
    :transition-duration="250"
    helper-class="shadow"
    @sort-start="onSortStart($event)"
    @sort-end="onSortEnd($event)"
  >
    <slick-item
      class="row"
      v-for="(field, field_idx) in fields"
      :key="field_idx"
      :index="field_idx"
      :disabled="drag_disabled"
      :class="{ selected: active(field) }"
    >
      <div v-if="design" class="handle" v-handle="true">
        <drag-vertical-icon :size="100"></drag-vertical-icon>
      </div>
      <div class="col" @mouseup="select_me($event, field)">
        <f-widget
          :design="design"
          :disabled="disabled"
          :field="fields[field_idx]"
          :field_index="field_idx"
          :fields="fields"
          :form-state="formState"
          :form-context="formContext"
          :item="item"
          :selector="selector"
          @change="change"
          @error="handleError"
          @fields-change="fields_changed"
        ></f-widget>
      </div>
    </slick-item>
  </slick-list>
</template>

<script>
import { HandleDirective, SlickItem, SlickList } from "vue-slicksort";
import DragVerticalIcon from "vue-material-design-icons/DragVertical.vue";
import { forEach, isEmpty } from "lodash";
import { FIELD_TYPES_BY_CODE } from "../field_types";

export default {
  name: "FWidgetList",
  directives: {
    handle: HandleDirective,
  },
  components: {
    SlickItem,
    SlickList,
    DragVerticalIcon,
  },
  data() {
    return {};
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    design: { type: Boolean, default: false },
    fields: { type: Array, default: () => [] },
    formState: {
      type: Object,
      default: () => {},
    },
    formContext: {
      type: Object,
      default: () => ({}),
    },
    selector: { type: Object, default: null },
    showHidden: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  methods: {
    handleError(msg) {
      this.$emit("error", msg);
    },
    change(item) {
      // Just propagate up
      console.log(`[${new Date().toISOString()}] FWidgetList @change event:`, {
        component: "FWidgetList",
        fieldsCount: this.fields.length,
        item: item,
      });
      this.$emit("change", item);
    },
    fields_changed(fields) {
      this.$emit("fields-change", fields);
    },
    active(field) {
      if (this.design) {
        if (this.selector) {
          return this.selector.field === field;
        }
      }

      return false;
    },
    select_me($event, field) {
      if (!this.selector.dragging) {
        if ($event && "stopPropagation" in $event) {
          $event.stopPropagation();
        }
      }

      if (this.selector) {
        this.selector.selectThis(field, this.fields);
      }
    },
    onSortStart($event) {
      // select the field we are dragging now
      this.select_me(this.fields[$event.index]);
      this.selector.dragging = true;
    },
    onSortEnd($event) {
      this.selector.dragging = false;
    },
  },
  computed: {
    drag_disabled() {
      // This disables all dragging on these
      return !this.design;
    },

    validations() {
      var result = {};

      if (this.design) {
        return result; // skip validation
      }
      forEach(this.fields, function (f) {
        const field_type = FIELD_TYPES_BY_CODE[f.field_type];
        if (field_type) {
          result[f.code] = field_type.validator(f);
        }
      });

      return result;
    },
    check_fields() {
      var results = {};
      if (this.design) {
        return results; // skip validation
      }

      const vm = this;
      if (this.item) {
        forEach(this.validations, function (valFunc, fieldName) {
          if (valFunc) {
            // Has a function
            const result = valFunc(vm.item);
            if (result != null) {
              // result is NOT null then there is an Error
              results[fieldName] = result;
            }
          }
        });
      }
      return results;
    },
    has_validation_errors() {
      if (this.design) {
        return false; // skip validation
      }
      return isEmpty(this.check_fields);
    },
  },
  mounted() {
    // Raise initial event so we have a Value
    this.$emit("on-validation", this.has_validation_errors);
  },
  watch: {
    has_validation_errors: function (newVal) {
      this.$emit("on-validation", newVal);
    },
  },
};
</script>
<style>
.handle {
  cursor: grab;
  width: 16px;
}

.selected {
  border: silver 1px solid;
  background-color: rgba(140, 210, 255, 0.45);
}
</style>
